import React, { useEffect, useState, Component } from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Ticker from 'react-ticker';
import PageVisibility from 'react-page-visibility';
import { useInView } from 'react-intersection-observer';
import { Wrapper, Image, Shape } from '../common';
import { toKebabCase, convertColorToHex } from '../../util/helpers';
import './ClientsTicker.scss';

const ClientsLogoTickerTemplate = (props) => {
  const {
    clients,
    data,
    isHome,
  } = props;
  const {
    primary,
  } = data;
  const {
    sectionTheme,
    title,
  } = primary;
  if (!clients || clients.length < 1) return null;
  const sectionHex = sectionTheme ? convertColorToHex(sectionTheme) : null;
  const [pageIsVisible, setPageIsVisible] = useState(true);
  let ref = null;
  let inView = null;
  if (isHome) {
    const [inViewRef, inViewBool] = useInView({
      /* Optional options */
      threshold: 0.2,
    });
    ref = inViewRef;
    inView = inViewBool;
    useEffect(() => {
      if (inView) document.documentElement.style.setProperty('--bg-colour', sectionHex);
    }, [inView]);
  }
  return (
    <section className="clients-ticker" ref={ref}>
      <Wrapper isBound>
        <h2 className="title">{title.text}</h2>
      </Wrapper>
      <div className="the-ticker">
        <PageVisibility onChange={(isVisible => setPageIsVisible(isVisible))}>
          { pageIsVisible && (
            <Ticker>
              {() => (
                <div className="clients">
                  {clients && clients.map(client => (
                    <div
                      className="client"
                      key={toKebabCase(client.businessName.text)}
                    >
                      {client.website ? (
                        <a
                          className="client-logo"
                          href={client.website.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div className="image-container">
                            <Image
                              image={client.logo}
                              className="contain"
                              alt={`The logo of ${client.businessName.text}`}
                            />
                          </div>
                        </a>
                      ) : (
                        <div
                          className="client-logo"
                          key={toKebabCase(client.businessName.text)}
                        >
                          <div className="image-container">
                            <Image
                              image={client.logo}
                              className="contain"
                              alt={`The logo of ${client.businessName.text}`}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </Ticker>
          )}
        </PageVisibility>
        <div className="framing-shapes">
          <Shape
            shapeName="pebbles"
            shapeColour="#EEEA00"
          />
          <Shape
            shapeName="mountain"
            shapeColour="#00BEE0"
          />
          <Shape
            shapeName="vessel"
            shapeColour="#2FCF00"
          />
          <Shape
            shapeName="flower"
            shapeColour="#FF6C13"
          />
          <Shape
            shapeName="square"
            shapeColour="#007307"
          />
          <div className="illustration illustration-eyes">
            <svg viewBox="0 0 184 124" xmlns="http://www.w3.org/2000/svg">
              <g fill="none" fillRule="evenodd">
                <path d="M1.723 77.28l7.95-13.403c3.624-4.567 8.456-7.747 14.498-9.541 9.061-2.69 14.933-3.763 25.633 0 2.942 1.035 5.714 1.79 8.319 2.267l5.826 2.43c6.652 5.973 10.382 11.258 11.189 15.856 1.21 6.897.427 25.609-10.204 35.811-10.63 10.203-18.388 10.397-28.755 12.825-10.367 2.428-22.782-7.435-28.954-15.688-5.657-7.565-7.014-12.365-7.2-16.16A20.53 20.53 0 010 90.667c0-2.638.574-7.1 1.723-13.387zM109.723 25.381l7.95-13.404c3.624-4.567 8.456-7.747 14.498-9.54 9.061-2.69 14.933-3.764 25.633 0 2.942 1.034 5.714 1.79 8.319 2.267l5.826 2.43c6.652 5.972 10.382 11.258 11.189 15.856 1.21 6.896.427 25.608-10.204 35.81-10.63 10.204-18.388 10.398-28.755 12.826-10.367 2.427-22.782-7.435-28.954-15.688-5.657-7.566-7.014-12.365-7.2-16.16a20.53 20.53 0 01-.025-1.011c0-2.637.574-7.1 1.723-13.386z" fill="#D6D7FF" />
                <path d="M118.752 18.69l3.975-6.701c1.812-2.284 4.229-3.874 7.25-4.77 4.53-1.346 7.466-1.882 12.816 0 1.47.517 2.857.894 4.16 1.133l2.913 1.215c3.326 2.986 5.19 5.629 5.594 7.928.606 3.448.214 12.804-5.102 17.905-5.315 5.102-9.194 5.199-14.377 6.413-5.184 1.214-11.392-3.717-14.477-7.844-2.829-3.783-3.507-6.183-3.6-8.08-.01-.172-.013-.34-.013-.506 0-1.318.287-3.55.861-6.692zM19.752 66.69l3.975-6.701c1.812-2.284 4.229-3.874 7.25-4.77 4.53-1.346 7.466-1.882 12.816 0 1.47.517 2.857.894 4.16 1.133l2.913 1.215c3.326 2.986 5.19 5.629 5.594 7.928.606 3.448.214 12.804-5.102 17.905-5.315 5.102-9.194 5.199-14.377 6.413-5.184 1.214-11.392-3.717-14.477-7.844-2.829-3.783-3.507-6.183-3.6-8.08-.01-.172-.013-.34-.013-.506 0-1.318.287-3.55.861-6.692z" fill="#0A85E5" />
              </g>
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

class ClientsLogoTicker extends Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query ClientsLogoTickerQuery {
            clients: prismicClientList {
              data {
                clients {
                  businessName: business_name {
                    text
                  }
                  logo {
                    alt
                    localFile {
                      childImageSharp {
                        fluid(maxWidth: 600) {
                          ...GatsbyImageSharpFluid_withWebp
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        `}
        render={data => (
          <ClientsLogoTickerTemplate
            {...this.props}
            clients={data.clients.data.clients}
          />
        )}
      />
    );
  }
}

export default ClientsLogoTicker;
